import z from "zod";

export const handleReviewEvent = {
  input: z.object({ email: z.string(), discountCode: z.string().optional() }),
  output: z.object({ success: z.boolean() }),
};
